"use client";

import Link from "next/link";
import { trackEvent } from "@/lib/gtag";

export default function TrackedLink({
  href,
  className,
  eventAction,
  eventParams,
  children,
}: {
  href: string;
  className?: string;
  eventAction: string;
  eventParams: Record<string, unknown>;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackEvent(eventAction, eventParams)}
    >
      {children}
    </Link>
  );
}
